// src/components/Workout/WorkoutHeader.js
import React, { useContext } from "react";
import LanguageContext from "../../../context/LanguageContext";

// point at the same JSON files…
import jsonDataEn from "../../data/data-en.json";
import jsonDataFr from "../../data/data-fr.json";

const WorkoutHeader = ({ formData }) => {
  const { language } = useContext(LanguageContext);
  const data = language === "en" ? jsonDataEn.data : jsonDataFr.data;

  // helper to look up the human-readable option text
  const look = (slideKey, optKey) => {
    // for slide5 we need to merge options + optionsPart2
    if (slideKey === "slide5") {
      return data.slide5.options?.[optKey] ?? data.slide5.optionsPart2?.[optKey] ?? optKey;
    }
    return data[slideKey].options?.[optKey] ?? data[slideKey][optKey] ?? optKey;
  };

  return (
    <header>
      {/* finalSlide is what you show once you land on /workout */}
      <div className="workout-header-container">
        <span className="workout-line" />
        <h1 className="display-4 fw-bolder text-capitalize mb-2 hero-title">
          {data.finalSlide.titleBefore}
          <span className="text-color">{data.finalSlide.titleRed}</span>
          {data.finalSlide.titleAfter}
        </h1>
        <span className="workout-line" />
      </div>

      {/* replicate your SlideResults-style summary using slideX lookups */}
      <div className="mb-4">
        <p className="fw-bold fs-5">
          {look("slide1", formData.sex)}
          <span className="text-color"> • </span>
          {look("slide2", formData.ageRange)}
          <span className="text-color"> • </span>
          {look("slide3", formData.fitnessGoal)}
          <span className="text-color"> • </span>
          {look("slide4", formData.experience)}
          <span className="text-color"> • </span>
          {look("slide5", formData.workout)}
          <span className="text-color"> • </span>
          {look("slide6", formData.time)}
          <span className="text-color"> • </span>
          {look("slide7", formData.intensity)}
        </p>
      </div>

      {/* QR code text from slide0 / finalSlide */}
      <div className="mb-5">
        <p>{data.slide0.description}</p>
      </div>
    </header>
  );
};

export default WorkoutHeader;
